/** Themes for colse button */
var CloseBtnTheme;
(function (CloseBtnTheme) {
    CloseBtnTheme["light"] = "light";
    CloseBtnTheme["gray"] = "gray";
    CloseBtnTheme["dark"] = "dark";
})(CloseBtnTheme || (CloseBtnTheme = {}));
export { CloseBtnTheme as C };
